import Container from './components/Container';
import { usePageViewEvent } from 'shared/gtm/hooks';

function LandingPage() {
  usePageViewEvent();

  return <Container />;
}

export default LandingPage;
